"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormatRegExp = exports.SEPARATORS = exports.NON_BREAKING_SPACE_CHARACTER = exports.DEFAULT_DOUBLE_CURRENCY_DELIMITER = void 0;
const DEFAULT_DOUBLE_CURRENCY_DELIMITER = exports.DEFAULT_DOUBLE_CURRENCY_DELIMITER = ' / ';
const NON_BREAKING_SPACE_CHARACTER = exports.NON_BREAKING_SPACE_CHARACTER = ' ';
let SEPARATORS = exports.SEPARATORS = /*#__PURE__*/function (SEPARATORS) {
  SEPARATORS["COMMA"] = ",";
  SEPARATORS["DOT"] = ".";
  return SEPARATORS;
}({});
const dateFormatRegExp = exports.dateFormatRegExp = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g;
